

import appsettings from '@/store/app-settings'
import {axiosGet, axiosPost}  from '@/store/api/axiosUtils.js'

const testGetAxios = (data) => {
    axiosGet(appsettings.ocpbComplaintAPIUrl + 'WeatherForecast', data).then(function (response) {
        // handle success
        console.log(response);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
        console.log('GET')
      });
}

const testPostAxios = (data) => {
    axiosPost(appsettings.ocpbComplaintAPIUrl + 'WeatherForecast', data).then(function (response) {
        // handle success
        console.log(response);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
        console.log('POST')
      });
}

export {testGetAxios, testPostAxios}